import {findMatchRange} from '../../utils/findMatchRange';

export type HighlightedColumnLabelProps = {
  text: string;
  searchTerm: string;
};

/**
 * Column label with the search-matched substring wrapped in a <mark>. Renders
 * the plain text when the term is empty or does not match (case- and
 * diacritics-insensitive, same rules as the search itself).
 */
export function HighlightedColumnLabel(props: HighlightedColumnLabelProps) {
  const range = findMatchRange(props.text, props.searchTerm);
  if (!range) {
    return <>{props.text}</>;
  }
  return (
    <>
      {props.text.slice(0, range.start)}
      {/* Inline style: the unlayered ComponentsProvider ResetCss can override
          utility classes, and mark's UA yellow would fight the row tints. */}
      <mark style={{backgroundColor: '#FFF0B3', color: 'inherit', borderRadius: '2px'}}>
        {props.text.slice(range.start, range.end)}
      </mark>
      {props.text.slice(range.end)}
    </>
  );
}
